import { Col, Form, Input, Row, Select } from 'antd';
import { FormInstance } from 'antd/lib/form';
import _ from 'lodash';
import React, {useContext, useEffect, useState} from 'react';
import { useAppSelector } from '../../../../hooks';
import { selectValues } from '../../../../reducers/settings';
import {calculateMonths, ParseDateRange, parseDateRange} from '../../../../reducers/util';
import { QueryBuilderContext, QueryBuilderContextType } from '../../QueryBuilderContext';
import {dateRangeValues} from "../DateRange";

interface Props {
    form: FormInstance
    fieldId: string
    fieldName: string // label in UI
}

const { Option } = Select

export const FDD_PERIOD = 'fdd_period_opcrdc'

const PeriodFilter = ({
    form,
    fieldId,
    fieldName,
}: Props) => {

    const { dataset } = useContext(QueryBuilderContext) as QueryBuilderContextType
    const settings = useAppSelector(selectValues)!
    const rangeValue = dateRangeValues(dataset, settings)

    let parseRange: ParseDateRange | undefined = undefined
    if (_.isString(rangeValue)) {
        parseRange = parseDateRange(rangeValue)
    } else if (_.isArray(rangeValue)) {
        const separated = rangeValue.map(i => {
            const j = i.value.split(',')
            return { start: j[0], end: j[1]}
        })
        const min = _.min(separated.map(i => i.start))
        const max = _.max(separated.map(i => i.end))
        parseRange = parseDateRange(`${min},${max}`)
    }

    if (fieldId === FDD_PERIOD && parseRange) {
        parseRange.startMonth = 1
        parseRange.startYear = 1900
    }

    const { monthYear } = calculateMonths(parseRange!)

    const startFrom = monthYear[0]
    const endTo = monthYear[monthYear.length - 1]

    const value = form.getFieldValue(fieldId)
    useEffect(() => {
        if (value) {
            const from = value[0]
            const to = value[1]
            form.setFieldsValue({
                from: from,
                to: to,
                [`${fieldId}_labels`]: [`${from} to ${to}`]
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value])

    const [index, setIndex] = useState<number>(0)

    const onChange = () => {
        let from = form.getFieldValue('from') ?? startFrom
        let to = form.getFieldValue('to') ?? endTo
        form.setFieldValue(fieldId, [from, to])
        form.setFieldValue(`${fieldId}_labels`, [`${from} to ${to}`])

        const _index = _.indexOf(monthYear, from)
        if (index !== _index) {
            setIndex(_index)
        }
    }

    const _index = _.indexOf(monthYear, startFrom)
    if (index !== _index) {
        setIndex(_index)
    }

    return <>
        <Row>
            <Form.Item name={fieldId} hidden={true}>
                <Input />
            </Form.Item>
            <Form.Item name={`${fieldId}_labels`} hidden={true}>
                <Input />
            </Form.Item>
            <Col span={12} style={{ padding: "5px" }}>
                <Form.Item name={'from'} label={'From'} initialValue={startFrom}>
                    <Select
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={onChange}
                        data-testid={'from'}
                    >
                        {monthYear.map(i => <Option key={i} value={i}>{i}</Option>)}
                    </Select>
                </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "5px" }}>
                <Form.Item name={'to'} label={'To'} initialValue={endTo}>
                    <Select
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={onChange}
                        data-testid={'to'}
                    >
                        {
                            monthYear
                                .slice(index)
                                .map(i => <Option key={i} value={i}>{i}</Option>)
                        }
                    </Select>
                </Form.Item>
            </Col>
        </Row>
    </>

}

export default PeriodFilter